import { render } from "./Preview.vue?vue&type=template&id=0d5e5986"
import script from "./Preview.vue?vue&type=script&lang=js"
export * from "./Preview.vue?vue&type=script&lang=js"
script.render = render

export default script